import { useTranslation } from 'react-i18next';

import { formatPromoCountdown } from './formatPromoCountdown';

interface PromoCountdownProps {
  remainingMs: number;
}

export const PromoCountdown = ({ remainingMs }: PromoCountdownProps) => {
  const { t } = useTranslation();
  const formatted = formatPromoCountdown(remainingMs);

  return (
    <div className="shrink-0 whitespace-nowrap rounded-full bg-graphic-regular-white desktop:px-6 px-4 py-1.5 font-bold font-customer-heading desktop:text-3xl text-graphic-regular-red text-lg tabular-nums desktop:leading-9 leading-6">
      {'days' in formatted
        ? t('phrases:promoDaysLeft', { count: formatted.days })
        : formatted.clock}
    </div>
  );
};
